import { useQuery } from '@tanstack/react-query';
import { useFormikContext } from 'formik';
import { func } from 'prop-types';

import { Button } from '@hivebrite/design-system/Button';

import { getCurrentValues } from 'hb-react/frontoffice/apps/Filters/form/getCurrentValues';
import { usePeopleDirectoryContext } from 'hb-react/frontoffice/apps/PeopleDirectory/contexts/PeopleDirectoryContext';
import { getPeopleDirectoryUsers } from 'hb-react/frontoffice/apps/PeopleDirectory/utils/getPeopleDirectoryUsers';
import { useAmplitude } from 'hb-react/shared/hooks/useAmplitude';

const useUsersFilteredCount = ({ values }) => {
  const {
    geoBoundingBoxFilter,
    config: { routes },
  } = usePeopleDirectoryContext();

  const { isFetching, data: { total } = {} } = useQuery({
    queryKey: ['totalPreFilteredItems', values.query],
    queryFn: ({ signal }) =>
      getPeopleDirectoryUsers({
        signal,
        fetchPeopleDirectoryUsers: routes.fetchPeopleDirectoryUsers,
        filters: getCurrentValues({ values }),
        geoBoundingBoxFilter,
        onlyUsersCount: true,
      }).then((data) => data),
  });

  return { isLoading: isFetching, total };
};

const ButtonShowTotalPreFilteredItems = ({ onClose }) => {
  const { values, submitForm } = useFormikContext();
  const { isLoading, total } = useUsersFilteredCount({ values });
  const { trackEvent } = useAmplitude();

  const handleShowTotalItemsFiltered = () => {
    submitForm();
    trackEvent('PeopleDirectory|User submits filter modal', { total });
    onClose();
  };

  return (
    <Button isLoading={isLoading} onClick={handleShowTotalItemsFiltered}>
      {total === undefined
        ? __('Show users')
        : n__('Show %{total} user', 'Show %{total} users', total).i__({
            total,
          })}
    </Button>
  );
};

ButtonShowTotalPreFilteredItems.propTypes = {
  onClose: func.isRequired,
};

export default ButtonShowTotalPreFilteredItems;
